
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import { updateEditableProperty } from "@/lib/components/editable-properties";
import { PropertyEditableInComponent } from "@/types/components";

@Component({
  components: { TextInput }
})
export default class ComponentEditablePropertySettings extends Vue {
  @Prop()
  path!: string;

  @Prop()
  propertyEditableInComponent!: PropertyEditableInComponent;

  updateLabel(newLabel: string) {
    updateEditableProperty(this.path, {
      ...this.propertyEditableInComponent,
      label: newLabel
    });
  }

  updatePropertyKey(newPropertyKey: string) {
    updateEditableProperty(this.path, {
      ...this.propertyEditableInComponent,
      propertyKey: newPropertyKey
    });
  }
}
